import type { App } from 'vue'
import * as directives from '@/directive/index'
import SvgIcon from '@/components/svgIcon/index.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const directivesCopy: any = directives
export default {
  install: (app: App): void => {
    app.component('svg-icon', SvgIcon) //注册全局组件

    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    // 批量自定义指令
    Object.keys(directivesCopy).forEach((vo: any) => {
      app.directive(vo, directivesCopy[vo])
    })
  }
}
